import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";
import { IResponseFormat } from "libs/data-access/types";

export const useFlightCommissionData = () => {
    const getFlightCommissionData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}flight/commissions${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postFlightCommissionData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}flight/commissions${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}flight/commissions${url && url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putFlightCommissionData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}flight/commissions${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchFlightCommissionData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}flight/commissions${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteFlightCommissionData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}flight/commissions${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getFlightCommissionData,
        postFlightCommissionData,
        putFlightCommissionData,
        patchFlightCommissionData,
        deleteFlightCommissionData
    };

};